import { ERROR_MESSAGE } from "constants/index";
import { http } from "config/http";
import { http4013 } from "config/http4013";
import { http4014 } from "config/http14";

export const getAnswer = async (data: string, Client: string | null, botId: string, user_name: string | null, handler_name: string | undefined) => {
    try {
        const res: any = await http.post(`ask_query?client_env=${localStorage.getItem("clientName")}&bot_name=${Client}&question=${data}${user_name !== "" ? `&user_name=${user_name}` : ""}&conversation_id=${botId}&handler_name=${handler_name !== undefined ? handler_name : ""}`)
        // const res: any = await http.post(`ask_query?client_env=${localStorage.getItem("clientName")}&bot_name=${Client}&question=${data}${localStorage.getItem("chatUserName") !== null && localStorage.getItem("chatUserName") !== "" ? `&user_name=${localStorage.getItem("chatUserName")}` : ""}&conversation_id=${botId}`)
        return { result: res?.data }

    } catch (error: any) {
        return { error: error.message }
    }
}

export const getAnswerTest = async (data: string, Client: string | null, botId: string, user_name: string | null, page_flag_ui?: boolean, context?: any) => {
// export const getAnswerTest = async (data: string, Client: string | null, botId: string, user_name: string | null, handler_name: string | undefined, page_flag_ui?: boolean, context?: any) => {
    try {
        let queryParams = `ask_query_test?client_env=${localStorage.getItem("clientName")}&bot_name=${Client}&question=${data}${user_name !== "" ? `&user_name=${user_name}` : ""}&conversation_id=${botId}`;
        // let queryParams = `ask_query_test?client_env=${localStorage.getItem("clientName")}&bot_name=${Client}&question=${data}${user_name !== "" ? `&user_name=${user_name}` : ""}&conversation_id=${botId}&handler_name=${handler_name !== undefined ? handler_name : ""}`;
        
        if (page_flag_ui !== undefined) {
            queryParams += `&page_flag_ui=${page_flag_ui}`;
        }
        if (page_flag_ui === true && context) {
            queryParams += `&context=${encodeURIComponent(JSON.stringify(context))}`;
        }
        
        const res: any = await http.post(queryParams)
        // const res: any = await http.post(`ask_query?client_env=${localStorage.getItem("clientName")}&bot_name=${Client}&question=${data}${localStorage.getItem("chatUserName") !== null && localStorage.getItem("chatUserName") !== "" ? `&user_name=${localStorage.getItem("chatUserName")}` : ""}&conversation_id=${botId}`)
        return { result: res?.data }

    } catch (error: any) {
        return { error: error.message }
    }
}

interface QueryObject {
    Question: string;
    SQLQuery: string;
    Ans: string;
}

type BotConfigurationResponse = {
    bot_name: string | null,
    organization_info: {
        organization_name: string,
        organization_url: string,
        domain_name: string,
        description: string
    },
    bot_config_info: {
        bot_name: string,
        initial_message: string,
        bot_logo: string,
        bot_logo_name: string,
        avtar_logo_name: string,
        avatar_logo: string,
        header_colour: string,
        question_background_colour: string,
        answer_background_colour: string,
        font_type: string,
        font_size: number
    },
    db_credentials_info: {
        csv_data: string,
        csv_name: string,
        host: string,
        port: number,
        user_name: string,
        password: string,
        db_name: string,
        tables: string[]
    },
    question_answer_info: {
        Question_Answer: QueryObject[],
    },
    config_info_change: {
        temperature: number,
        max_token: number
    },
    spipeet_info: {
        snipeet_code: string
    },
    is_config_info: boolean,
    is_question_answer: boolean,
    is_csv: boolean,
    created_by: string
}

export const botConfigurations = async (data: any) => {
    const destinationObject = { ...data, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.post(`bot_configurations`, destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const follow_up_question = async (question: string, user_name: string | null, botId: string) => {
    try {
        const res: any = await http.post(`follow_up_question?client_env=${localStorage.getItem("clientName")}&follow_up_question=${question}${user_name !== "" ? `&user_name=${user_name}` : ""}&conversation_id=${botId}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}
export const gift_recommendation = async (question: string, user_name: string | null, botId: string) => {
    try {
        const res: any = await http.post(`gift_recommendation?client_env=${localStorage.getItem("clientName")}&user_query=${question}${user_name !== "" ? `&user_name=${user_name}` : ""}&conversation_id=${botId}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const botSearchRecommendation = async (question: string, conversation_id: string) => {
    try {
        const res: any = await http.post(`bot_search_recommendation?client_env=${localStorage.getItem("clientName")}&question=${question}${conversation_id !== "" ? `&conversation_id=${conversation_id}` : ""}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getBotConfigurations = async (id: string | null) => {
    try {
        const res: any = await http.get(`get_bot_configurations_new/?bot_name=${id}&client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const botAnalysis = async (id: string) => {
    const destinationObject = { conversation_id: id, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http4013.post(`bot-analysis`, destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const memoryClear = async () => {
    try {
        const res: any = await http4014.post(`clear_memory`)
        return { result: res?.data }

    } catch (error: any) {
        return { error: error }
    }
}

export const botProductPageChat = async (body: any) => {
    try {
        const res: any = await http.post(`product_page_chat`, body)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getRecommendationsStyleIdeas = async (body: any) => {
    try {
        const res: any = await http.post(`style_ideas?client_env=${localStorage.getItem("clientName")}&product_id=${body.product_id}${body.user_name !== "" ? `&user_name=${body.user_name}` : ""}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const bundlingSuggestion = async (body: any) => {
    try {
        const res: any = await http.post(`bot_brought_recommendation?client_env=${localStorage.getItem("clientName")}&product_id=${body.product_id}${body.user_name !== "" ? `&user_name=${body.user_name}` : ""}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getHandler = async (val: string, oldValue: string | undefined) => {
    try {
        const res = await http.get(`generate_handler?client_env=${localStorage.getItem("clientName")}&handler_name=${val}&old_handler_name=${oldValue}`)
        return { result: res?.data };
    } catch (error: any) {
        return { error: error.message }
    }
}

type user_story_bundling_type = {
    client_env: string | null,
    user_name?: string,
    handler_name: string,
    product_id: string,
    conversation_id: string,
}

export const user_story_bundling_api = async (body: user_story_bundling_type) => {
    try {
        const res = await http.post('user_story_bundling', body)
        return { result: res?.data };
    } catch (error: any) {
        return { error: error.message }
    }
}

export const vc_csv_upload = async (body: any) => {
    try {
        const res = await http.post(`vc_csv_upload`, body)
        return { result: res?.data };
    } catch (error: any) {
        return { error: error.message }
    }
}

export const vc_room_upload = async (body: any) => {
    try {
        const res = await http.post(`vc_room_upload`, body)
        return { result: res?.data };
    } catch (error: any) {
        return { error: error.message }
    }
}